export default 
{
	"progressbar-page-title": "Sivu",
	"name-suffix": "Pääte",
	"fileupload-desc-progress-message": "Ladataan {progress}",
	"required-if-greater-than-or-equal": "{property} on pakollinen, kun {compareSource} on suurempi tai yhtä suuri kuin {compareValue}.",
	"powered-by-cognito": "Rakennettu Cognito Forms avulla.",
	"form-name-default": "Nimetön",
	"field-choice-defaults": "Ensimmäinen vaihtoehto|Toinen vaihtoehto|Kolmas vaihtoehto",
	"additional-fee-default-label": "Lisämaksu",
	"authenticated-save-and-resume-email-dialog": "Lähetä linkki sähköpostitse ja palaa lomakkeelle viimeistelläksesi lähetyksen.",
	"string-length-between": "{property} on oltava välillä {min} ja {max} merkkiä.",
	"update-button-text": "Päivittää",
	"address-zip-code-invalid": "Zip Code on muotoiltu #####-####.",
	"required-if-greater-than": "{property} on pakollinen, kun {compareSource} on suurempi kuin {compareValue}.",
	"compare-before": "{property} on oltava ennen {compareSource}.",
	"compare-after": "{property} on oltava jälkeen {compareSource}.",
	"unsupported-browser-message": "Oh No! Käytät tuettu selain. {a}Päivitä napsauttamalla tätä{/a}.",
	"shared-entry-email-subject": "Jaettu -linkki",
	"send-button-text": "Lähetä",
	"venmo-help-text": "Jatkaa maksamista yhdistämällä Venmoiin.",
	"field-repeatingsection-item-label": "Erä",
	"save-and-resume-email-not-sent-message": "Oli ongelma.",
	"credit-card-cvv": "CVV",
	"range-at-least": "{property} on oltava vähintään {min}.",
	"entry-notification-full-entry-detail-link": "Tarkastele kaikkia lomakkeen tietoja palvelussa cognitoforms.com.",
	"element-label-website": "Verkkosivusto",
	"element-label-signature": "Allekirjoitus",
	"paypal-help-text": "Jatkaa maksamista yhdistämällä PayPaliin.",
	"card-on-file-agreement-validation": "Sinun on suostuttava tallentamaan korttisi tulevia tapahtumia varten.",
	"marketing-button-4": "Rakenna Oma Ilmaiseksi",
	"field-datepicker-now": "Nyt",
	"save-and-resume-email-resume-button": "Jatka nyt",
	"field-datepicker-next-month": "Seuraava kuukausi",
	"quantity-remaining-text": "jäljelle jäänyt",
	"payment-declined": "Maksu hylätty",
	"required-if-before": "{property} on pakollinen, kun {compareSource} on ennen {compareValue}.",
	"this-comma-that": "{0}, {1}",
	"compare-less-than": "{property} on oltava pienempi kuin {compareSource}.",
	"entry-admin-link": "Ylläpidon linkki",
	"required-many": "{0} ovat pakollisia.",
	"save-and-resume-multiple-days-expiration-email-message": "Käytä alla olevaa linkkiä palataksesi lomakkeellesi lomakkeellesi {days} päivän kuluessa viimeistelläksesi lomakkeen tietoja.",
	"string-length-at-least": "{property} on oltava vähintään {min} merkkiä.",
	"credit-card-number": "Luottokorttinumero",
	"range-on-or-before": "{property} on oltava ennen {max}.",
	"required-one": "{0} on pakollinen.",
	"fileupload-max-file-count-exceeded-message": "Vain {maxFileCount} tiedostoja voidaan ladata.",
	"order-transaction-details-header": "Tapahtumatiedot",
	"field-spinner-increase": "Lisääntyä",
	"payment-processing-fees": "Käsittelymaksut",
	"payment": "Maksu",
	"field-choice-other-fill-in": "Muut",
	"shared-entry-email-message": "Lomakkeelle tallennettu tieto on jaettu sinulle.",
	"shared-entry-workflow-link": "Katso lomake.",
	"required-if-exists": "{property} on pakollinen, kun {compareSource} on määritetty.",
	"concurrent-conflict-toast-message": "Lähettämisesi epäonnistui, koska tämän lomakkeen tiedot ovat muuttuneet. Tarkista ja yritä uudelleen.",
	"secured-by-paypal": "turvattu",
	"range-on-or-after": "{property} on oltava tai sen jälkeen {min}.",
	"payment-amount-due": "Maksettava summa",
	"required-name-first-and-last": "Etunimi ja Sukunimi ovat pakollisia.",
	"required": "{property} on pakollinen.",
	"string-format-alphabetic": "{property} saa olla vain kirjaimia.",
	"quantity-limit": "{property} määrä ylitetty.",
	"field-spinner-decrease": "Vähennä",
	"field-repeatingsection-add-link-text": "Lisää",
	"fileupload-max-size-exceeded-message": "Vain tiedostojen pienempi kuin {maxSize} MB voidaan ladata.",
	"credit-card-expiration": "MM/YY",
	"field-signature-notcaptured": "Ei vastaanotettu",
	"field-ratingscale-satisfied-unsatisfied-label": "Tyytyväinen/Tyytymätön",
	"range-between": "{property} on oltava välillä {min} ja {max}.",
	"field-ratingscale-agree-disagree-label": "Samaa Mieltä/Eri Mieltä",
	"back-button-text": "Takaisin",
	"address-country": "Maa",
	"order-not-found": "Ei tilaustiedot löytynyt.",
	"field-ratingscale-satisfied-unsatisfied-options": "Erittäin tyytymätön|Tyytymätön|Neutraali|Tyytyväinen|Erittäin tyytyväinen",
	"entry-notification-entry-details-header": "Tiedot",
	"FALSE": "EI TOTTA",
	"compare-greater-than-or-equal": "{property} on oltava suurempi tai yhtä suuri kuin {compareSource}.",
	"receipt-notification-order-details-desc-header": "Kuvaus",
	"order-method-label": "Menetelmä",
	"order-total-label": "Tilaa yhteensä",
	"invalid-shared-link": "Virheellinen Jaettu -linkki",
	"fileupload-zero-byte-file-message": "Zero tavu tiedostoja ei voi ladata.",
	"range-at-most": "{property} on oltava korkeintaan {max}.",
	"format-integer": "####",
	"order-date-label": "Päivämäärä",
	"fileupload-dropzone-message": "tai vedä tiedostot tänne.",
	"shared-entry-view-link": "Tarkastele jaettua tietoa.",
	"format-currency": "# ###,## €",
	"string-length-at-most": "{property} on oltava korkeintaan {max} merkkiä.",
	"entry-confirmation-footer-tagline": "Luo omia lomakkeita maksamista varten",
	"submit-button-text": "Lähetä",
	"marketing-msg": "Luo helposti tehokkaita lomakkeita.",
	"required-if-on-or-after": "{property} on pakollinen, kun {compareSource} on tai sen jälkeen {compareValue}.",
	"card-on-file-agreement": "Hyväksyn kortin tallentamisen tulevia tapahtumia varten.",
	"signature-draw": "piirtää",
	"address-zip-code": "Zip Code",
	"compare-on-or-after": "{property} on oltava tai sen jälkeen {compareSource}.",
	"required-if-less-than-or-equal": "{property} on pakollinen, kun {compareSource} on vähemmän kuin tai yhtä suuri kuin {compareValue}.",
	"field-datepicker-next-year": "Seuraava vuosi",
	"change-button": "muuttaa",
	"fileupload-desc-size-in-bytes-message": "{size} tavua",
	"card-tab": "Kortti",
	"order-billing-info-header": "Laskutustiedot",
	"entry-email-view-details-text": "Tarkastele kaikkia lomakkeen tietoja palvelussa cognitoforms.com",
	"save-and-resume-one-day-expiration-email-message": "Käytä alla olevaa linkkiä palataksesi lomakkeellesi seuraavan päivän kuluessa viimeistelläksesi lomakkeen tietoja.",
	"credit-card-authentication-failed": "Kortti epäonnistui.",
	"compare-less-than-or-equal": "{property} on oltava pienempi tai yhtä suuri kuin {compareSource}.",
	"receipt-notification-order-details-balance-due": "Maksettava summa",
	"save-and-resume-multiple-days-expiration-message": "Kopioi tai lähetä sähköpostilla alla oleva linkki ja palaa lomakkeellesi {days} päivän kuluessa viimeistelläksesi lomakkeen tietoja.",
	"processing-fee-calculating-message": "Laskee",
	"receipt-notification-trx-details-method": "Menetelmä",
	"field-choice-no-match": "Ei vastaavia tietoja",
	"fileupload-invalid-file-type-message": "Vain {allowedTypes} tiedostoja voidaan ladata.",
	"receipt-notification-trx-details-date": "Päivämäärä",
	"credit-card-authorization": "Kortin valtuutus",
	"address-line1": "Osoiterivi 1",
	"required-if-not-exists": "{property} on pakollinen, kun {compareSource} ei ole määritetty.",
	"required-if-not-equal": "{property} on pakollinen, kun {compareSource} ei {compareValue}.",
	"marketing-button-2": "Rakenna Oma Ilmaiseksi",
	"receipt-notification-billing-info-header": "Laskutustiedot",
	"required-if-after": "{property} on pakollinen, kun {compareSource} on sen jälkeen {compareValue}.",
	"element-label-name": "Nimi",
	"required-if-equal": "{property} on pakollinen, kun {compareSource} on {compareValue}.",
	"connected-to-paypal": "Yhdistetty PayPaliin.",
	"people-form-email-quantity-exceeded-message": "Sähköpostiosoitteen on oltava yksilöllinen.",
	"receipt-notification-order-details-subtotal": "Välisumma",
	"shared-entry-edit-link": "Muokkaa jaettua tietoa.",
	"receipt-notification-trx-details-header": "Tapahtumatiedot",
	"address-city": "Kaupunki",
	"receipt-notification-order-details-amount-paid": "Maksettu määrä",
	"credit-card-invalid": "Kortti on virheellinen.",
	"format-decimal": "####,##",
	"entry-notification-new-submission-text": "Olet saanut uuden lomakelähetyksen.",
	"this-and-that": "{0} ja {1}",
	"field-ratingscale-good-poor-label": "Hyvä/Huono",
	"network-unavailable-message": "Verkko ei ole käytettävissä, yritä myöhemmin uudelleen.",
	"dialog-close": "Lopettaa",
	"string-format-alphanumeric": "{property} on sisältää vain kirjaimia ja numeroita.",
	"credit-card": "Luottokortti",
	"remove-item": "Poista {item}",
	"receipt-notification-order-details-price-header": "Hinta",
	"fileupload-upload-inprogress-message": "Tiedostojen siirto käynnissä.",
	"public-terms-of-service-link-text": "Käyttöehdot",
	"save-and-resume-email-subject": "Tallenna ja jatka -linkki",
	"field-repeatingsection-remove-link-text": "Poista",
	"field-ratingscale-na-label": "N/A",
	"add-item": "Lisää {item}",
	"field-toggle-options": "Kyllä/Ei|Tosi/Epätosi|Auki/Kiinni|Käytössä/Ei Käytössä|Luettu/Lukematon",
	"order-submit-timeout": "Tilausten käsittely kestää liian kauan. Yritä tehdä tilaus myöhemmin.",
	"listlength-at-most": "Ilmoitathan enintään {max} {property}.",
	"shared-entry-email-view-message": "Käytä alla olevaa linkkiä nähdäksesi jaettua tietoa.",
	"order-number-label": "Numero",
	"card-declined": "Kortti hylätty",
	"fileupload-default-upload-button-text": "Lataa",
	"name-prefix": "Titteli",
	"address-line2": "Osoiterivi 2",
	"element-label-email": "Sähköposti",
	"field-ratingscale-good-poor-options": "Erittäin huono|Huono|Keskimääräinen|Hyvä|Erittäin hyvä",
	"next-button-text": "Seuraava",
	"question": "Kysymys",
	"address-postalcode": "Postinumero / Zip Code",
	"format-with-description": "{property} on muotoiltu {description}.",
	"field-datepicker-prev-month": "Edellinen kuukausi",
	"name": "Nimi",
	"receipt-notification-order-details-total-footer": "Yhteensä",
	"confirmation-message": "Kiitos kun täytit lomakkeen tiedot. Vastauksesi on tallennettu.",
	"shared-entry-email-edit-message": "Käytä alla olevaa linkkiä muokataksesi jaettua tietoa.",
	"field-default-label": "Nimetön",
	"required-value": "{property} on {value}.",
	"name-middle": "Toinen nimi",
	"fileupload-failed-upload-message": "{fileName} ei voi ladata.",
	"shared-entry-email-button-label": "Näytä lomakke tietoja.",
	"field-datepicker-year": "",
	"element-label-phone": "Puhelin",
	"TRUE": "TOTTA",
	"listlength-between": "Ilmoitathan välillä {min} ja {max} {property}.",
	"marketing-button-1": "Kokeile Nyt",
	"entry-submission-error-heading": "Virhe syötetyn tiedon käsittelyssä.",
	"order-not-found-message": "Tilaustietoja ei löytynyt",
	"format-without-description": "{property} ei ole oikein muotoiltu.",
	"name-last": "Sukunimi",
	"field-ratingscale-one-five-label": "Asteikolla 1-5",
	"listlength-at-least": "Ilmoitathan vähintään {min} {property}.",
	"united-states": "Yhdysvallat",
	"field-signature-captured": "Vastaanotettu",
	"compare-on-or-before": "{property} on oltava ennen {compareSource}.",
	"order-balance-due-label": "Maksettava summa",
	"required-if-less-than": "{property} on pakollinen, kun {compareSource} on pienempi kuin {compareValue}.",
	"credit-card-postalcode": "Postinumero",
	"form-not-available-message": "Tämä lomake ei ole tällä hetkellä saatavilla.",
	"element-label-address": "Osoite",
	"receipt-notification-trx-details-number": "Numero",
	"public-submission-warning": "Älä lähetä salasanoja Cognito Forms -palvelun kautta.",
	"save-and-resume-no-expiration-email-message": "Käytä alla olevaa linkkiä palataksesi lomakkeellesi viimeistelläksesi lomakkeen tietoja.",
	"fileupload-excluded-file-type-message": "Tämäntyyppisiä tiedostoja ei voitu ladata.",
	"payment-subtotal": "Välisumma",
	"collapse": "Tiivistää",
	"save-button-text": "Tallenna",
	"field-datepicker-prev-year": "Edellinen vuosi",
	"signature-type": "kirjoittaa",
	"order-amount-minimum": "Saatavan on oltava vähintään 1,00 €.",
	"string-format-numeric": "{property} on sisältää vain numeroita.",
	"entry-confirmation-entry-details-header": "Tiedot",
	"connected-to-venmo": "Yhdistetty Venmoon.",
	"format-percentage": "#,## %",
	"receipt-notification-header": "Kuitti",
	"clear": "Poistaa",
	"today": "Tänään",
	"required-name-last": "Sukunimi on pakollinen.",
	"marketing-button-3": "Kokeile Nyt",
	"expand": "Laajenna",
	"compare-greater-than": "{property} on oltava suurempi kuin {compareSource}.",
	"field-ratingscale-will-wont-label": "Luultavasti/Luultavasti Ei",
	"required-name-first": "Etunimi on pakollinen.",
	"save-and-resume-one-day-expiration-message": "Kopioi tai lähetä sähköpostilla alla oleva linkki ja palaa lomakkeellesi seuraavan päivän kuluessa viimeistelläksesi lomakkeen tietoja.",
	"required-asterisk": "pakollinen",
	"credit-card-required": "Luottokortti tarvitaan.",
	"address-state-province-region": "Osavaltio/Maakunta/Kunta",
	"save-and-resume-email-sent-message": "Sähköpostiviesti on lähetetty.",
	"workflow-action": "Toiminta",
	"field-ratingscale-will-wont-options": "Varmasti ei|Luultavasti ei|Ei varma|Luultavasti|Varmasti",
	"save-and-resume-email-label": "Lähetä minulle linkki sähköpostitse:",
	"field-ratingscale-agree-disagree-options": "Täysin eri mieltä|Eri mieltä|Neutraali|Samaa mieltä|Täysin samaa mieltä",
	"order-exception-order-already-paid": "Tämä tilaus on jo maksettu.",
	"fileupload-download-text": "Lataa",
	"address-state": "Osavaltio",
	"allowed-values": "{property} ei ole sallittujen arvojen luettelo.",
	"shared-entry-workflow-email-button-label": "Avaa lomake",
	"compare-equal": "{property} on oltava sama kuin {compareSource}.",
	"field-datepicker-clear": "Tyhjennä",
	"name-first": "Etunimi",
	"save-and-resume-message": "Antamasi tiedot on tallennettu",
	"save-and-resume-no-expiration-message": "Kopioi tai lähetä sähköpostilla alla oleva linkki ja palaa lomakkeellesi viimeistelläksesi lomakkeen tietoja.",
	"entry-notification-view-details-text": "Näytä tiedot",
	"order-exception-default-message": "Tapahtuman käsittely ei onnistu.",
	"public-report-abuse-link-text": "Ilmoita väärinkäytöstä",
	"order-amount-paid": "Maksettu määrä",
	"element-label-default": "Nimetön",
	"countries": "Afganistan|Alankomaat|Alankomaiden Antillit|Albania|Algeria|American Samoa|Andorra|Angola|Anguilla|Antigua ja Barbuda|Argentiina|Armenia|Aruba|Australia|Azerbaidzan|Bahama|Bahrain|Bangladesh|Barbados|Belgia|Belize|Benin|Bermuda|Bhutan|Bolivia|Bosnia ja Hertsegovina|Botswana|Brasilia|Brunei Darussalam|Bulgaria|Burkina Faso|Burundi|Caymansaaret|Chile|Cocos (Keeling) Islands|Cookinsaaret|Costa Rica|Demokraattinen tasavalta Kongon (Kinshasa)|Djibouti|Dominica|Dominikaaninen tasavalta|Ecuador|Egypti|El Salvador|Eritrea|Espanja|Etelä-Afrikka|Etelämanner|Etelä-Sudan|Etiopia|Falklandin saaret|Fidži|Filippiinit|Färsaaret|Gabon|Gambia|Georgia|Ghana|Gibraltar|Grenada|Grönlanti|Guadeloupe|Guam|Guatemala|Guinea|Guinea-Bissaun|Guyanan|Haiti|Honduras|Hong Kong|Indonesia|Intia|Irak|Iran (islamilainen tasavalta)|Irlanti|Islanti|Iso-Britannia|Israel|Italia|Itä-Timorin (Itä-Timor)|Itävalta|Jamaika|Japani|Jemen|Jordania|Joulusaari|Kambodža|Kamerun|Kanada|Kap Verde|Kazakstan|Kenia|Keski-Afrikan tasavalta|Kiina|Kirgisistan|Kiribati|Kolumbia|Komorien|Kongon tasavallan of(Brazzaville)|Korea, demokraattisen \u0027 s Rep (Pohjois-Korea)|Korean tasavalta (Etelä-Korea)|Kosovon|Kreikka|Kroatia|Kuuba|Kuwait|Kypros|Lao, ihmiset \u0027 demokraattinen tasavalta|Latvia|Lesotho|Libanon|Liberia|Libya|Liechtenstein|Liettua|Luxemburg|Länsi-Sahara|Macao|Madagaskar|Pohjois-Makedonian tasavalta|Malawi|Malediivit|Malesia|Mali|Malta|Mansaari|Marokko|Marshall Islands|Martinique|Mauritania|Mauritius|Mayotte|Meksiko|Mikronesia, osavaltioiden|Moldovan tasavalta|Monaco|Mongolia|Montenegro|Montserrat|Mosambik|Myanmar Burma|Namibia|Nauru|Neitsytsaaret (US)|Nepal|Nicaragua|Niger|Nigeria|Niue|Norja|Norsunluurannikko|Oman|Pakistan|Palau|Palestiinalaisalueilla|Panama|Papua-Uusi-Guinea|Paraguay|Peru|Pitcairn Island|Pohjois-Mariaanit|Portugali|Puerto Rico|Puola|Pyhä istuin|Päiväntasaajan Guinea|Qatar|Ranska|Ranskan eteläiset alueet|Ranskan Guayana|Ranskan Polynesia|Reunion saari|Romania|Ruandan|Ruotsi|Saint Kitts ja Nevis|Saint Lucia|Saint Vincent ja Grenadiinit|Saksa|Salomonsaaret|Sambia|Samoa|San Marino|Saudi-Arabia|Senegal|Serbia|Seychellit|Sierra Leonen|Singapore|Slovakian (Slovakia)|Slovenia|Somalia|Sri Lanka|Sudan|Suomi|Suriname|Swazimaa|Sveitsi|Syyria, Syyria|Tadžikistanin|Taiwan (Kiina)|Tansaniassa. virallisesti Tansanian yhdistynyt tasavalta|Tanska|Thaimaa|Tiibetin|Togo|Tokelau|Tonga|Trinidad ja Tobago|Tšad|Tšekin tasavalta|Tunisia|Turkki|Turkmenistan|Turks and Caicos Islands|Tuvalu|Uganda|Ukraina|Unkari|Uruguay|Uusi-Kaledonia|Uusi-Seelanti|Uzbekistan|Valko-Venäjä|Wallis-ja Futunasaaret|Vanuatu|Vatikaanivaltio (Pyhä istuin)|Venezuela|Venäjä|Vietnam|Virgin Islands (British)|Viro|Yhdistyneet arabiemiirikunnat|Yhdysvallat|Zimbabwe",
	"name-middleinitial": "MI",
	"order-exception-empty-order": "Tilauksessa tulee olla vähintään yksi nimike.",
	"compare-not-equal": "{property} on oltava eri {compareSource}.",
	"entry-notification-footer": "Olet tämän sähköpostin vastaanottaja koska olet Cognito Forms-lomakkeessa valinnut vaihtoehdon Vastaanota sähköposti-ilmoituksia.",
	"save-and-resume-copy-link-label": "Kopioi lomakkeesi linkki:",
	"entry-confirmation-footer": "Olet tämän sähköpostin vastaanottaja koska olet asioinut [Name] -nimisen organisaation kanssa ",
	"required-if-on-or-before": "{property} on pakollinen, kun {compareSource} on viimeistään {compareValue}.",
	"string-format": "{property} on alustettu {formatDescription}."
};
